import { render, staticRenderFns } from "./SmileyButton.vue?vue&type=template&id=1179316f"
import script from "./SmileyButton.vue?vue&type=script&lang=ts"
export * from "./SmileyButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports